export const queryKeys = {
    ALL_STARTED_TEST: 'all-started-test'
};

export const testTypes = {
    TOPIC_TEST: "mavzuli",
    VIRTUAL_TEST: "virtual",
    DTM_TEST: "dtm",
    UNIVERSITY_TEST: "university",
}
